import {transmission, USER_ROOT, WEB_METHODS} from "@/network";
import store from "@/store";

const DEFULAT_SOLUTIONS = () => {
    //TODO. 추후 API 연동 후 삭제 예정
    return [
        { unitUseNo:0, unitNm:'마음날씨', helpfulIcon:'ic_mindWeather.svg', dailyUnitYn:'Y', freeYn: 'Y'},
        { unitUseNo:0, unitNm:'마음노트', helpfulIcon:'ic_mindNote.svg', dailyUnitYn:'Y', freeYn: 'Y'},
        { unitUseNo:0, unitNm:'당신의 빌런은 번아웃?\uD83E\uDD26‍♂️', helpfulIcon:'ic_condition_01.svg',
            dailyUnitYn:'N', freeYn: 'N', lock:'Y', unitTypeNm: "워크시트형",  unitTypeCnt: 4},
        { unitUseNo:0, unitNm:'휴식이 필요한 순간\uD83E\uDDD8‍♀️',
            helpfulIcon:'ic_condition_04.svg',
            dailyUnitYn:'N', freeYn: 'N', lock:'Y',unitTypeNm: "몸 알아차리기",  unitTypeCnt: 3},
        { unitUseNo:0, unitNm:'나와 화해하기\uD83E\uDD1D', helpfulIcon:'ic_condition_01.svg',
            dailyUnitYn:'N', freeYn: 'N' , lock:'Y', unitTypeNm:"몰입훈련형", unitTypeCnt: 1},
    ]
}

const DEFAULT_USE_ORD_DTL = () => {
    return {
        travelYn: '',
        travelStopYn: '',
        usePeriodDays: 0,
        usePeriodStartDtSt: '',
        usePeriodEndDtSt: '',
        travelMapIcon: false,
        nullData: false
    }
}

const DEFULAT_GUIDES = () => {
    return [
        {
            name: '포그니',
            character: 'ic_character1.svg',
            profile: 'guide/profile1.svg',
            question: 'guide/question1.png',
            questionApp: 'guide/questionApp2.svg',
            cheerup: 'guide/cheerup1.svg',
            checkPw: 'guide/check_pw1.png',
            continue: 'guide/continue1.svg',
            title: ['포그니', '포옹'],
            tag: ['따뜻', '포근'],
            text: `안아주는 걸 좋아함\n포옹으로 상대의 마음을\n포근하게 만들어주는 능력`
        },
        {
            name: '따미',
            character: 'ic_character2.svg',
            profile: 'guide/profile2.svg',
            question: 'guide/question2.png',
            questionApp: 'guide/questionApp2.svg',
            cheerup: 'guide/cheerup2.svg',
            checkPw: 'guide/check_pw2.png',
            continue: 'guide/continue1.svg',
            title: ['따미', '똘똘'],
            tag: ['객관적', '현실적'],
            text: `따뜻한 카리스마\n객관적인 시선과\n현실적인 조언을 날려주는 능력`
        },
        {
            name: '동동',
            character: 'ic_character3.svg',
            profile: 'guide/profile3.svg',
            question: 'guide/question3.png',
            questionApp: 'guide/questionApp2.svg',
            cheerup: 'guide/cheerup3.svg',
            checkPw: 'guide/check_pw3.png',
            continue: 'guide/continue1.svg',
            title: ['동동', '인싸'],
            tag: ['친근', '편안'],
            text: `특유의 친화력\n감정을 나누고\n마음에 공감하는 능력`
        },
        {
            name: '홍구',
            character: 'ic_character4.svg',
            profile: 'guide/profile4.svg',
            question: 'guide/question4.png',
            questionApp: 'guide/questionApp2.svg',
            cheerup: 'guide/cheerup4.svg',
            checkPw: 'guide/check_pw4.png',
            continue: 'guide/continue1.svg',
            title: ['홍구', '다부진', '눈썹'],
            tag: ['무심함 속에 넘치는 배려'],
            text: `모든 일에 진심\n친구가 스치듯이 말한 것들도\n놓치지 않는 기억력과 세심함`
        },
        {
            name: '포니',
            character: 'ic_character5.svg',
            profile: 'guide/profile5.svg',
            question: 'guide/question5.png',
            questionApp: 'guide/questionApp2.svg',
            cheerup: 'guide/cheerup5.svg',
            checkPw: 'guide/check_pw5.png',
            continue: 'guide/continue1.svg',
            title: ['포니', '긍정'],
            tag: ['에너지', '긍정'],
            text: `무한 긍정의 힘\n넘치는 에너지와\n긍정 체인징 능력`
        }
    ]
}

/**
 * 각종 Remote에 필요한 store
 * 적재된 데이터는 휘발되므로 휘발되도 상관없이 단순 페이지 제어용으로만 사용함
 */
const state = {
    guides: DEFULAT_GUIDES(),
    solutions: [],
    currentPlanIndex: 0,
    isSolutionComplete: false,
    isApplResult: '',
    initApplResult: false,
    solMappingYn: '',
    initSolMappingYn: false,
    travelApplFormAgree: false,
    obdCheckYn: '',
    applyYn:'', //동의 여부
    ordDtlCall: false,
    useOrdDtl: {
        travelYn: '',
        travelStopYn: '',
        usePeriodDays: 0,
        usePeriodStartDtSt: '',
        usePeriodEndDtSt: '',
        travelMapIcon: false,
        nullData: false
    },
    nickname: '',
    avatarImages: [
        { key: 0, url: require('@/assets/images/avatar/profile_img_00.jpg') },
        { key: 1, url: require('@/assets/images/avatar/profile_img_01.jpg') },
        { key: 2, url: require('@/assets/images/avatar/profile_img_02.jpg') },
        { key: 3, url: require('@/assets/images/avatar/profile_img_03.jpg') },
        { key: 4, url: require('@/assets/images/avatar/profile_img_04.jpg') },
        { key: 5, url: require('@/assets/images/avatar/profile_img_05.jpg') },
        { key: 6, url: require('@/assets/images/avatar/profile_img_06.jpg') }
    ],
    mindWeatherText: '........',
    sltCmplt: {
        cmpltYn: '',
        guideEvalYn: '',
        cmpltDt: null
    },
    sltCmpltCall: false,
    isChat: false,
    isFirst: true,
    isRealTalkNew : false
}

const mutations = {
    initRemote () {
      this.initSolutionComplete()
      this.initApplResult()
      this.initObdCheckYn()
      this.initSolMappingYn()
    },
    initApplyYn(state) {
        state.applyYn = '';
    },
    setApplyYn(state, payload) {
       state.applyYn = payload
    },
    initSolutionComplete (state) {
        state.isSolutionComplete = false
    },
    setSolutionComplete (state, payload) {
        state.isSolutionComplete = payload
    },
    initApplResult (state) {
        state.isApplResult = ''
    },
    initSolMappingYn (state) {
        state.solMappingYn = ''
    },
    setApplResultSuccess (state) {
        state.isApplResult = 'success'
    },
    setApplResultFail (state) {
        state.isApplResult = 'fail'
    },
    setTravelApplFormAgree (state, payload) {
        state.travelApplFormAgree = payload
    },
    setInitApplResult (state, payload) {
        state.initApplResult = payload
    },
    setSolMappingYnSuccess (state) {
        state.solMappingYn = 'success'
    },
    setSolMappingYnFail (state) {
        state.solMappingYn = 'fail'
    },
    setInitSolMappingYn (state, payload) {
        state.initSolMappingYn = payload
    },
    initObdCheckYn (state) {
        state.obdCheckYn = ''
    },
    setObdCheckYn (state, payload) {
        state.obdCheckYn = payload
    },
    initSolutions (state) {
        state.solutions = []
        state.currentPlanIndex = 0
    },
    setSolutions (state, payload) {
        state.solutions = payload
    },
    setCurrentPlanIndex (state, payload) {
        state.currentPlanIndex = payload
    },
    initUseOrdDtl (state) {
      state.useOrdDtl = DEFAULT_USE_ORD_DTL()
    },
    setUseOrdDtlSuccess (state, payload) {
        state.useOrdDtl = payload
        state.useOrdDtl.travelYn = 'Y'
        state.useOrdDtl.travelStopYn = 'N'
        state.useOrdDtl.travelMapIcon = true
    },
    setTravelFail (state, isNull) {
        state.useOrdDtl.travelYn = 'N'
        state.useOrdDtl.nullData = isNull
    },
    setTravelStop (state, payload) {
        state.useOrdDtl = payload
        state.useOrdDtl.travelYn = 'Y'
        state.useOrdDtl.travelStopYn = 'Y'
    },
    setTrueOrdDtlCall (state) {
        state.ordDtlCall = true
    },
    setTrueSltCmpltCall (state) {
        state.sltCmpltCall = true
    },
    setNickname (state, payload) {
        if (!payload) state.nickname = ''
        else state.nickname = payload
    },
    initNickname (state) {
        state.nickname = ''
    },
    setSltCmplt (state, payload) {
        state.sltCmplt = payload
    },
    initSltCmplt (state) {
        state.sltCmplt.cmpltYn = ''
        state.sltCmplt.guideEvalYn = ''
        state.sltCmplt.cmpltDt = null
    },
    setMindWeatherText (state, payload) {
        state.mindWeatherText = payload
    },
    setIsChat(state, payload) {
        state.isChat = payload
    },
    setIsFirst(state, payload) {
        state.isFirst = payload
    },
    setIsRealTalkNew(state, payload) {
        state.isRealTalkNew = payload
    },
}

const actions = {
    /**
     * 동의여부 확인 조회
     */
    async getServiceAgreementCheck({commit, state}) {
       if(!state.initApplyYn) {
           if(store.getters.clientCd==="b2c") { //일반
               commit("setApplyYn", 'Y');
           } else {
               await transmission(true, WEB_METHODS.GET, `${USER_ROOT}/member/agreementCheck`)
                   .then(res => {
                       if(res.success) {
                           if(res.data===1) {
                               commit("setApplyYn", 'Y');
                           } else {
                               commit("setApplyYn", 'N');
                           }
                       } else {
                           commit("setApplyYn", 'N');
                       }
                   }).catch((error) => {
                       commit("setApplyYn", 'N');
                       console.error(error)
                   }).finally(() => {})
           }

       }
    },

    /**
     * 회원 > 온보딩 확인 여부 조회
     */
    async getObdCheckYn ({commit, state}) {
        if (!state.obdCheckYn) {
            await transmission(true, WEB_METHODS.GET, `${USER_ROOT}/member/obd-check`)
                .then(res => {
                    if (res.success) {
                        commit('setObdCheckYn', res.data)
                    } else {
                        commit('setObdCheckYn', 'N')
                    }
                }).catch(() => {
                    commit('setObdCheckYn', 'N')
                }).finally(() => {})
        }
    },
    /**
     * 사용자 > 메인 > 오늘의 미션 리스트 API
     */
    async getTodayPlanList ({commit, state}, forceCall) {
        if (!state.solutions.length || forceCall) {
            await transmission(true, WEB_METHODS.GET, `${USER_ROOT}/main/today-plans`)
                .then(res => {
                    if (res.success) {
                        if (res.data.length > 0) {
                            res.data.forEach((element, index) => {
                                // 카테고리 노출 여부
                                if (element.unitType === '12' || element.unitType === '13' || element.unitType === '14' || element.unitType === '15' || element.unitType === '16') element.unitTypeNm = ''

                                // 완료 여부 및 진행 current 값 수정 -- 데일리유닛은 미완료여도 current 증가
                                if (element.dailyUnitYn === 'Y'){
                                    if(element.cmpltYn === 'Y'){
                                        element.cmpltYn = true
                                    }else{
                                        element.cmpltYn = false
                                    }
                                    commit('setCurrentPlanIndex', (index + 1))

                                }else{
                                    if(element.cmpltYn === 'Y'){
                                        element.cmpltYn = true
                                        commit('setCurrentPlanIndex', (index + 1))
                                    }else{
                                        element.cmpltYn = false
                                    }
                                }

                                // 무료인경우 데일리 제외 잠금
                                if (element.freeYn === 'Y') {
                                    if (element.dailyUnitYn !== 'Y') {
                                        element.lock = true
                                    } else {
                                        element.lock = false
                                    }
                                } else {
                                    // NOTE. 중지 상태면 lock 처리.. 중지는 현재 사용 안하는걸로 알고 있음.
                                   element.lock = store.getters.useOrdDtl.useStatus == '01' ? element.inactive : true
                                }

                                if (element.unitType === '15') {   // 마음날씨 아이콘 -- 머지 이후 퍼블이 올려준 아이콘으로 변경 필요
                                    element.helpfulIcon = 'ic_mindWeather.svg'
                                } else if (element.unitType === '12') {    // 마음노트 아이콘
                                    element.helpfulIcon = 'ic_mindNote.svg'
                                } else {    // 그외 유닛은 첫번째 도움이되요 기준 아이콘
                                    element.helpful = element.helpful.substr(0, 2)
                                    element.helpfulIcon = 'ic_condition_' + element.helpful + '.svg'
                                    // console.log('element.helpful : ', element.helpful)
                                }

                            });
                            commit('setSolutions', res.data)
                        } else {
                            // 솔루션 유닛 맵핑 안된경우
                            commit('setSolutions', DEFULAT_SOLUTIONS())
                        }

                    } else {
                        commit('setSolutions', DEFULAT_SOLUTIONS())
                    }
                })
                .catch(() => {
                    commit('initSolutions')
                })
        }
    },
    async getUseOrdDtl ({commit, state}, forceCall) {
        if (!state.ordDtlCall || forceCall) {
            await transmission(true, WEB_METHODS.GET, `${USER_ROOT}/order/use-ord-dtl`)
                .then(res => {
                    if (res.success) {
                        if (res.data !== null ) {
                            if(res.data.useStatus === '01'){
                                commit('setUseOrdDtlSuccess', res.data)
                            } else {
                                commit('setTravelStop', res.data)
                            }
                        } else {
                            commit('setTravelFail', true)
                        }
                    } else {
                        commit('setTravelFail')
                    }
                })
                .catch(() => {
                    commit('setTravelFail')
                })
                .finally(() => {
                    commit('setTrueOrdDtlCall')
                })
        }
    },
    async getUserNickname ({commit, state}) {
        if (state.nickname === '') {
            await transmission(true, WEB_METHODS.GET, `${USER_ROOT}/member/nickname`)
                .then(res => {
                    if (res.success) {
                        commit('setNickname', res.data)
                    } else {
                        commit('initNickname')
                    }
                }).catch(() => {
                    commit('initNickname')
                })
        }
    },
    async getUserSltCmplt({commit, state}) {
        if (state.useOrdDtl.travelYn == 'Y' && state.useOrdDtl.ordDtlNo != undefined) {
            await transmission(true, WEB_METHODS.GET, `${USER_ROOT}/member/slt-cmplt/${state.useOrdDtl.ordDtlNo}`)
                .then(res => {
                    if (res.success && res.data != null) {
                        commit('setSltCmplt', res.data)
                    } else {
                        commit('initSltCmplt')
                    }
                }).catch(() => {
                    commit('initSltCmplt')
                }).finally(() => {
                    commit('setTrueSltCmpltCall')
                })
        }
      },
      async getHeaderRealtalk({commit, state}) {
        if(!state.isChat){
             await transmission(true, WEB_METHODS.GET, `${USER_ROOT}/realtalk/realtalk`)
            .then(res => {
              if (res.data != null) {
                commit('setIsChat', res.data.isChat)
                if (res.data.message != null) {
                    commit('setIsFirst', false)
                    for (let i = res.data.message.length - 1; i > -1; i--) {
                      let message = res.data.message[i];

                      // console.log(message.userReadYn);
                      if(message.userType != 'dms-user' && (message.userReadYn !== true)){
                        commit('setIsRealTalkNew', true)
                      } else {
                        commit('setIsRealTalkNew', false)
                      }
                    }
                  }
              }
            })
            .catch(error => {
              console.error(error)
            })
            .finally(() => {
            })
        }
      },

}

const getters = {
    applyYn(state) {
       return state.applyYn
    },
    obdCheckYn (state) {
        return state.obdCheckYn
    },
    isApplResult (state) {
        return state.isApplResult
    },
    travelApplFormAgree (state) {
        return state.travelApplFormAgree
    },
    solMappingYn (state) {
        return state.solMappingYn
    },
    solutionComplete (state) {
        return state.isSolutionComplete
    },
    solutions (state) {
        return state.solutions
    },
    currentPlanIndex (state) {
        return state.currentPlanIndex
    },
    useOrdDtl (state) {
        return state.useOrdDtl
    },
    nickname (state) {
        return state.nickname
    },
    initApplResult (state) {
        return state.initApplResult
    },
    initSolMappingYn (state) {
        return state.initSolMappingYn
    },
    avatarImages (state) {
        return state.avatarImages
    },
    mindWeatherText (state) {
        return state.mindWeatherText
    },
    guides (state) {
        return state.guides
    },
    cmpltYn (state) {
        return state.sltCmplt.cmpltYn
    },
    guideEvalYn (state) {
        return state.sltCmplt.guideEvalYn
    },
    cmpltDt (state) {
        return state.sltCmplt.cmpltDt
    },
    isChat (state) {
        return state.isChat
    },
    isFirst (state) {
        return state.isFirst
    },
    isRealTalkNew (state) {
        return state.isRealTalkNew
    },
}

export default { state, mutations, actions, getters }
